import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

export function TableRow({ className, clickable, ...props }) {
  return (
    <tr className={classNames(clickable && styles.table_row__clickable, className)} {...props} />
  );
}

TableRow.propTypes = {
  className: PropTypes.string,
  clickable: PropTypes.bool,
};
